import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Logos from "../../components/Logos";
import React, {useEffect} from 'react';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { animateScroll as scroll } from 'react-scroll'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { selectIsChallengeSelected, selectIsTargetRoleSelected, setIsChallengeSelected, setIsTargetRoleSelected } from "../../redux/skillSlice";
import NewLogo from "../../components/NewLogo";

const Layout = () => {

    const { pathname } = useLocation()
    const isChallengeSelected = useSelector(selectIsChallengeSelected)
    const isTargetRoleSelected = useSelector(selectIsTargetRoleSelected)
    const dispatch = useDispatch()

    const navigate = useNavigate()

    useEffect(() => {
        scroll.scrollToTop();
    }, []);
  
    const backButton = pathname === '/ffe-signup/roadmap-details' || (pathname === '/onboarding/1' && isTargetRoleSelected)
    const showNewLogo = pathname === "/" || pathname === "/onboarding/pricing"
    // const showNewLogo = false
    
    return (
        <div  className={`w-full mx-auto h-[100dvh] flex flex-col overflow-y-scroll bg-[#012A4A]`} style={{backgroundImage: 'radial-gradient(circle, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%)'}}>
            <ToastContainer />
            <div className={`${backButton && 'max-w-2xl'} relative w-full mx-auto flex items-center ${showNewLogo ? 'px-0' : 'px-4'}`}>
                {backButton && <FontAwesomeIcon icon={faArrowLeft} className="-mb-2 md:absolute md:left-0 text-xl text-white cursor-pointer" onClick={() =>{
                if(pathname === '/onboarding/1'){
                    if(isTargetRoleSelected){
                        dispatch(setIsChallengeSelected(false));
                        dispatch(setIsTargetRoleSelected(false));
                    } else {
                        dispatch(setIsChallengeSelected(false));
                    }
                } else {
                    navigate(-1)
                }
                    
                    
                }}/>}
                {showNewLogo ? <NewLogo /> : <Logos />}
            </div>
            <Outlet />
        </div>
  )
}

export default Layout